import WelcomeCard from "./Comps/WelcomeCard";
import Footer from "../Miscel/Footer";
import { useEffect, useState } from "react";
import { ip } from "../../config";
import EventListTitle from "./Comps/EventsList/EventsListTitle";
import EventList from "./Comps/EventsList/EventList";
import React from 'react'
import { ThreeDots } from  'react-loader-spinner'



const Homepage = () => {

    const [cardInfo,setCardInfo] = useState([]);
    const [sortMethod,setSortMethod] = useState("alumniName");
    const [fetchStatus,setFetchStatus] = useState("loading");
    const [eventsPage, setEventsPage] = useState(0);
    const [pageEnd, setPageEnd] = useState(false);

    useEffect(() => {                
        fetch(ip+"/events?page="+eventsPage+"&value=10&sort="+sortMethod)
        .then(res => {            
            if(res.status===200){
                return res.json();
            }              
            throw new Error("Something went wrong, Failed to fetch");                      
        })
        .then(data => {
            setCardInfo(data);
            if(data.length<10) setPageEnd(true);
            setFetchStatus("success");
        })
        .catch(err => alert("Please contact admin(error occured): "+err));
    }
    , [sortMethod,eventsPage]);

    
    
    return ( 
        <>
            <WelcomeCard/>          
            <EventListTitle setSortMethod={setSortMethod} eventsPage={eventsPage} setEventsPage={setEventsPage} pageEnd={pageEnd}/>  
            <EventList cardInfo={cardInfo} fetchStatus={fetchStatus}/>            
            <Footer/>            
        </>
     );
}
 
export default Homepage;